import { Select, styled } from '@mui/material';
import { outlinedInputClasses } from '@mui/material';

export const CustomSelectField = styled(Select, {
  shouldForwardProp: (props) => props !== 'focusColor',
})((e) => {
  const focusColor = e.theme.palette.secondary.main;
  const white = e.theme.palette.whiteText.main;

  return {
    [`& .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: white,
    },
    [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: focusColor,
    },
    [`&.${outlinedInputClasses.focused} .${outlinedInputClasses.notchedOutline}`]:
      {
        borderColor: focusColor,
      },

    '.MuiSelect-iconOutlined': {
      color: white,
    },
  };
});
